export const stripHtmlAndTruncate = (str = '', maxLength = 150) => {
  const strippedStr = str.replace(/(<([^>]+)>)/gi, '');

  if (strippedStr.length <= maxLength) {
    return strippedStr;
  }

  return strippedStr.substring(0, maxLength) + '...';
};
